module.exports = __webpack_public_path__ + "static/cta-moc-2-1-c792d36ea6fb0b2d865fcc0f8d888e01.png";